module.exports = __webpack_public_path__ + "static/media/target-customer.91aa1b86.svg";